// extracted by mini-css-extract-plugin
export var brand = "_92-9";
export var compact = "_92-6";
export var extraSmall = "_92-7";
export var icon = "_92-0";
export var large = "_92-4";
export var light = "_92-1";
export var medium = "_92-5";
export var outline = "_92-b";
export var primaryDark = "_92-a";
export var primaryLight = "_92-8";
export var primaryModern = "_92-c";
export var success = "_92-2";
export var successSolid = "_92-3";